import React from 'react';
import closeIcon from '../images/close popup.png';
import warningImg from '../../../images/Warning.png';
import Button from '../../Button';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';

const LaunchpadPopUp = (
    {
        onChangeInput,
        valueInput = '',
        isCanContinue = true,
        close = () => {},
        confirmFunc = () => {},
        featuresList = []
    }) => (
    <div className='popUp' >
        <div className='launchpad-popUp'>
            {close && <img className='close' src={closeIcon} alt='close popup' onClick={close}/>}
            <div className='launchpad-popUp-layout'>
                <img alt='warning icon' className='warning-icon' src={warningImg}/>
                <div className='launchpad-popUp-main'>
                    <p className='launchpad-popUp-main-title'>{_SYSTEM_TITLES.launchpadPopUpTitle}</p>
                    <p className='launchpad-popUp-main-sub-title'>{_SYSTEM_TITLES.launchpadPopUpSubTitle}</p>
                    <ul className='launchpad-popUp-ul'>
                        {featuresList.map((feature:any) => <li key={feature.name}>
                            <p>{feature.name}<span className='launchpad-popUp-ul-inner'> - version:</span> v{feature.version}</p>
                        </li>)}
                    </ul>
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    <p className='launchpad-popUp-main-sub-title-input'>{_SYSTEM_TITLES.launchpadPopUpSubTitleConfirmTitle1} <span style={{color: 'red'}}>"Confirm"</span> {_SYSTEM_TITLES.launchpadPopUpSubTitleConfirmTitle2}</p>
                    <input type='text'
                        onChange={(e) => onChangeInput && onChangeInput(e.target.value)}
                        className='launchpad-popUp-main-input'
                        value={valueInput && valueInput}
                    />
                </div>
            </div>
            <div className='launchpad-popUp-btns-container'>
                <Button
                    onClick={close}
                    isDisabledActive={false}
                    classNameButton='btn-inner'>
                    Cancel
                </Button>
                <Button
                    onClick={() => isCanContinue && confirmFunc()}
                    isDisabledActive={false}
                    classNameButton={`btn-main ${!isCanContinue && 'show-opacity'}`}>
                    Confirm
                </Button>
            </div>
        </div>
    </div>
);

export default LaunchpadPopUp;
